import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-button',
  imports: [CommonModule, MatRippleModule],
  template: `
    <button
      type="button"
      mat-ripple
      class="tw-rounded-lg tw-h-full tw-bg-white tw-py-2 tw-px-4
        tw-gap-[0.25em] tw-flex-wrap
        tw-inline-flex tw-items-center tw-justify-center"
    >
      <ng-content></ng-content>
    </button>
  `,
})
export class ButtonComponent {}
